import api from './api';

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  refreshToken: string;
  user: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    profilePictureUrl?: string;
    preferredLanguage?: string;
    timeZone?: string;
  };
  organizationId: string;
}

export const login = async (email: string, password: string) => {
  return api.post<LoginResponse>('/auth/login', { email, password });
};

export const register = async (userData: {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  organizationId: string;
  preferredLanguage?: string;
  timeZone?: string;
}) => {
  return api.post<LoginResponse>('/auth/register', userData);
};

export const refreshToken = async (token: string, refreshTokenValue: string) => {
  return api.post<LoginResponse>('/auth/refresh-token', { token, refreshToken: refreshTokenValue });
};

export const getCurrentUser = async () => {
  return api.get('/auth/me');
};

export default api;
